import { httpClient } from '../http/httpClient'

export interface PanDetails {
  id: string
  status: string
  name: string
  cpf: string
  email: string
  phone: string
  idOriginador: string
  observation: string | null
  selectedLetter: string | null
  deadlines: string[]
  letter: string | null
  linkNumber: string | null
  amount: number | null
  employerRegistrationCode: string | null
  employerRegistrationNumber: string | null
  employerName: string | null
  priceId: string | null
  numPan: string | null
  linkFormalization: string | null
  createdAt: string
  updatedAt: string
  partnerId: string
  url: string
}

export async function getPanId(id: string) {
  const { data } = await httpClient.get<PanDetails>(`/pan/${id}`)
  return data
}
